"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _reactStatic = require("react-static");

var _Link = require("../../../../../../react-static/components/Link");

var _TipList = require("../../../../tip/components/TipList");

var _ThingTypeList = require("../../../../packing/components/ThingTypeList");

var _HtmlRender = require("../../../../../../react-static/components/HtmlRender");

var _ReactStaticPage = require("../../../../../../react-static/page/ReactStaticPage");

var _Breadcrumbs = require("../../../../../../components/Breadcrumb/Breadcrumbs");

var _Category = require("../Category");

var _Packing = require("../../Packing");

var _class;

var ThingTypesInCategoryTemplate = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ThingTypesInCategoryTemplate, _React$Component);

  function ThingTypesInCategoryTemplate(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = ThingTypesInCategoryTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        categoryDescription = _this$props.categoryDescription,
        thingTypes = _this$props.thingTypes,
        tips = _this$props.tips;
    var path = this.props.path;
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
      items: [{
        label: _Packing.PackingTitle
      }, {
        label: _Category.PackingCategoryTitle,
        to: _Category.PackingCategoryPath
      }]
    }), _react.default.createElement("p", null, _react.default.createElement(_Link.Link, {
      to: path + "#packing-items"
    }, "Skip to Items to add to your Packing List")), _react.default.createElement(_HtmlRender.HtmlRender, {
      html: categoryDescription
    }), tips && tips.length > 0 && _react.default.createElement(_TipList.TipList, {
      tips: tips,
      linkPath: path
    }), _react.default.createElement(_ThingTypeList.ThingTypeList, {
      thingTypes: thingTypes
    }));
  };

  return ThingTypesInCategoryTemplate;
}(_react.default.Component)) || _class;

var _default = (0, _reactStatic.withRouteData)(ThingTypesInCategoryTemplate);

exports.default = _default;